// GENERATED FILE, PLEASE DO NOT EDIT
var BannerDefault = 4;
var ButtonTabDefault = 4;
var ButtonToggleDefault = 4;
var ButtonToggleGroupLarge = 4;
var ButtonToggleGroupMedium = 4;
var ButtonToggleGroupSmall = 4;
var ButtonDefault = 4;
var IconButtonDefault = 4;
var FieldsInputDefault = 4;
var FieldsInputConnectedWrapperDefault = 4;
var ModalDefault = 8;
var PaginationDefault = 4;
var PopoverContainerDefault = 4;
var ToastContainer = 6;
var ToggleTypeCheckbox = 2;
var TooltipContainer = 4;
var BorderRadiusSemanticsAll = {
  BannerDefault: BannerDefault,
  ButtonDefault: ButtonDefault,
  ButtonTabDefault: ButtonTabDefault,
  ButtonToggleDefault: ButtonToggleDefault,
  ButtonToggleGroupLarge: ButtonToggleGroupLarge,
  ButtonToggleGroupMedium: ButtonToggleGroupMedium,
  ButtonToggleGroupSmall: ButtonToggleGroupSmall,
  FieldsInputConnectedWrapperDefault: FieldsInputConnectedWrapperDefault,
  FieldsInputDefault: FieldsInputDefault,
  IconButtonDefault: IconButtonDefault,
  ModalDefault: ModalDefault,
  PaginationDefault: PaginationDefault,
  PopoverContainerDefault: PopoverContainerDefault,
  ToastContainer: ToastContainer,
  ToggleTypeCheckbox: ToggleTypeCheckbox,
  TooltipContainer: TooltipContainer
};

export { BannerDefault, BorderRadiusSemanticsAll, ButtonDefault, ButtonTabDefault, ButtonToggleDefault, ButtonToggleGroupLarge, ButtonToggleGroupMedium, ButtonToggleGroupSmall, FieldsInputConnectedWrapperDefault, FieldsInputDefault, IconButtonDefault, ModalDefault, PaginationDefault, PopoverContainerDefault, ToastContainer, ToggleTypeCheckbox, TooltipContainer, BorderRadiusSemanticsAll as default };
